import React from 'react';
import { FaBan } from "react-icons/fa";

const CantAccessPage = () => {
    return (
        <div className="container d-flex justify-content-center align-items-center">
            <div className="text-center">
                <div className="icon-container d-flex justify-content-center align-items-center mb-4">
                    {/* Access Denied Icon */}
                    <FaBan style={{ fontSize: '5rem', color: '#dc3545'}} />
                </div>
                <h1 className="display-4">Access Denied</h1>
                <p className="lead">You do not have permission to access this page.</p>
                <button className="btn btn-danger mt-4" onClick={() => window.history.back()}>
                    Go Back
                </button>
            </div>
        </div>
    );
};

export default CantAccessPage;
